/**
 * Development-only error logger.
 * In production builds (`NODE_ENV === "production"`) all methods are no-ops,
 * keeping the console clean while preserving fail-safe error paths in code.
 */
const IS_DEV = process.env.NODE_ENV !== "production";

// eslint-disable-next-line no-console
export const logDebug = IS_DEV ? console.debug.bind(console) : () => {};
// eslint-disable-next-line no-console
export const logWarn = IS_DEV ? console.warn.bind(console) : () => {};
// eslint-disable-next-line no-console
export const logError = IS_DEV ? console.error.bind(console) : () => {};

export default { logDebug, logWarn, logError };
